import AdobeIcon from '/imports/checkout/ui/assets/AdobeIcon';
import AiIcon from '/imports/checkout/ui/assets/AiIcon';
import {
  CheckoutCtaListIcon1,
  CheckoutCtaListIcon2,
  CheckoutCtaListIcon3,
} from '/imports/checkout/ui/assets/CheckoutCtaListIcons';
import Clothes from '/imports/checkout/ui/assets/Clothes';
import DeltaAirIcon from '/imports/checkout/ui/assets/DeltaAirIcon';
import GoogleIcon from '/imports/checkout/ui/assets/GoogleIcon';
import IkeaIcon from '/imports/checkout/ui/assets/IkeaIcon';
import LikeIcon from '/imports/checkout/ui/assets/LikeIcon';
import { EqualToIcon, ReviewIcon, UpArrowIcon } from '/imports/checkout/ui/assets/MergeDesignIcons';
import MicroSoftIcon from '/imports/checkout/ui/assets/MicroSoftIcon';
import {
  NewlyIcon1,
  NewlyIcon2,
  NewlyIcon3,
  NewlyIcon4,
  NewlyIcon5,
  NewlyIcon6,
} from '/imports/checkout/ui/assets/NewlyCheckoutIcons';
import PdfIcon from '/imports/checkout/ui/assets/PdfIcon';
import SupportIcon from '/imports/checkout/ui/assets/SupportIcon';
import Texi from '/imports/checkout/ui/assets/Texi';
import { Design1Icon1, Design1Icon2, Design1Icon3 } from '/imports/checkout/ui/assets/UpsellPageIcons';
import UserTrade from '/imports/checkout/ui/assets/UserTrade';
import { staticFile } from '/lib/helpers';

// Checkout A/B experiments
export const EXPERIMENT_1 = 'EXP 1';
export const EXPERIMENT_1A = 'EXP 1A';
export const EXPERIMENT_2 = 'EXP 2';
export const EXPERIMENT_3 = 'EXP 3';
export const EXPERIMENT_5 = 'EXP 5';

// list of PSP's billing version which should have the experiement 3, STRIPE:1, SOLID:5
export const NEW_PRICING_EXP_3_BILLING_VERSIONS = [5];

//list of country with close pricing exp
export const CLOSE_PRICING_COUNTRY = [
  'AR',
  'EC',
  'EG',
  'BR',
  'ID',
  'LT',
  'MX',
  'MA',
  'PH',
  'SA',
  'ES',
  'SE',
  'TH',
  'AE',
  'LV',
  'FR',
  'NL',
  'NO',
  'CL',
  'CO',
];

export const CLOSE_PRICING_COUNTRY_BROWSER_ONLY_NEW_BROWSER = ['CL'];

export const NEW_PRICING_FOR_BOTH = ['BR', 'ID', 'LT', 'MX', 'MA', 'PH', 'SA', 'ES', 'AE', 'LV', 'NL'];

export const NEW_PRICE_FOR_BROWSER_AND_RUN_MOBILE = ['ZA'];

export const CONTROL_BROSWER_RUN_MOBILE = ['AU'];

export const NEW_PRICE_ON_BROWSWER_CONTROL_MOBILE = ['FR'];

// Chargebee payment plan experiments
export const CB_EXPERIMENT_1 = 'EXP_1';

export const CARD_DETAILS_FIELD_STATES = {
  COMPLETE: 'complete',
  EMPTY: 'empty',
  INCOMPLETE: 'incomplete',
};

export const CARD_LOGOS = {
  visa: staticFile('img/visa.png'),
  mastercard: staticFile('img/mastercard.png'),
};

export const DISABLE_CHECKOUT_PRICING = ['TR', 'VN', 'PK', 'BR', 'PE', 'MX', 'TH', 'BD', 'IN'];

export const PAYMENT_CONTENT = [
  { icon: <LikeIcon />, content: 'payment_content_1' },
  { icon: <PdfIcon />, content: 'payment_content_2' },
  { icon: <AiIcon />, content: 'payment_content_3' },
  { icon: <SupportIcon />, content: 'payment_content_4' },
];

export const USER_RATING_INFORMATION = [
  {
    imageUrl: staticFile(`img/hero4.jpg`),
    userName: 'RAJENDRA',
  },
  {
    imageUrl: staticFile(`img/hero5.jpg`),
    userName: 'JULIE',
  },
  {
    imageUrl: staticFile(`img/hero6.jpg`),
    userName: 'ASHLEY',
  },
];

export const NEW_CHECKOUT_TESTIMONIAL = [
  {
    src: staticFile('img/checkout/avatar-1.jpg'),
    text: 'testimonial1',
    author: 'new_checkout_testimonial_female_name',
    job: 'sales_manager',
  },
  {
    src: staticFile('img/checkout/avatar-2.jpg'),
    text: 'testimonial2',
    author: 'new_checkout_testimonial_male_name',
    job: 'accountant',
  },
];

export const NEW_CHECKOUTPAGE_PRICING_POINTS = [
  { title: 'new_checkout_pricing_point_title_1', subTitle: `new_checkout_pricing_point_subtitle_1` },
  {
    title: 'new_checkout_pricing_point_title_2',
    subTitle: `new_checkout_pricing_point_subtitle_2`,
  },
  {
    title: 'new_checkout_pricing_point_title_3',
    subTitle: `new_checkout_pricing_point_subtitle_3`,
  },
  {
    subTitle: `new_checkout_pricing_point_subtitle_4`,
  },
  {
    subTitle: `new_checkout_pricing_point_subtitle_5`,
  },
];

export const NEW_CHECKOUT_MOBILE_POINT_SECTION = [
  { title: 'mobile_new_checkout_left_point_1' },
  { title: 'mobile_new_checkout_left_point_2' },
  { title: 'mobile_new_checkout_left_point_3' },
  { title: 'newly_left_subtitle_6' },
  { title: 'mobile_new_checkout_left_point_5' },
];

export const NEWLY_LEFT_SECTION_DATA = [
  {
    icon: <NewlyIcon1 />,
    title: 'newly_left_title_1',
    subTitle: 'newly_left_subtitle_1',
    autoApplyIcon: '🚀',
    autoApplytitle: 'offer_title_1',
    autoApplySubtitle: 'offer_title_1_1',
  },
  {
    icon: <NewlyIcon2 />,
    title: 'newly_left_title_2',
    subTitle: 'newly_left_subtitle_2',
    autoApplyIcon: '💼',
    autoApplytitle: 'offer_title_2',
    autoApplySubtitle: 'offer_title_2_1',
  },
  {
    icon: <NewlyIcon3 />,
    title: 'newly_left_title_3',
    subTitle: 'newly_left_subtitle_3',
    autoApplyIcon: '📝',
    autoApplytitle: 'offer_title_3',
    autoApplySubtitle: 'offer_title_3_1',
  },
  {
    icon: <NewlyIcon4 />,
    title: 'newly_left_title_4',
    subTitle: 'newly_left_subtitle_4',
    autoApplyIcon: '🎯',
    autoApplytitle: 'offer_title_4',
    autoApplySubtitle: 'offer_title_4_1',
  },
  {
    icon: <NewlyIcon5 />,
    title: 'newly_left_title_5',
    autoApplyIcon: '📊',
    autoApplytitle: 'offer_title_5',
    autoApplySubtitle: 'offer_title_5_1',
  },
  {
    icon: <NewlyIcon6 />,
    title: 'newly_left_title_6',
    subTitle: 'newly_left_subtitle_6',
    autoApplyIcon: '🧰',
    autoApplytitle: 'offer_title_6',
    autoApplySubtitle: 'offer_title_6_1',
  },
];

export const NEW_CHECKOUT_CTA_BOTTOM_LIST = [
  { icon: <CheckoutCtaListIcon1 />, title: 'new_checkout_cta_bottom_list_1' },
  { icon: <CheckoutCtaListIcon2 />, title: 'new_checkout_cta_bottom_list_2' },
  { icon: <CheckoutCtaListIcon3 />, title: 'new_checkout_cta_bottom_list_3' },
];

export const ACTIVE_PAYPAL_GEO = ['US', 'CA', 'DE', 'AU', 'NZ', 'GB'];

export const ACTIVE_SOLID_PAYPAL_SITE = ['cv-lite', 'resume-example', 'resumedone'];

export const UPSELL_PAGE_DESIGN_1 = [
  {
    icon: <Design1Icon1 />,
    title: 'upsell_pagev1_feature1_title',
    subTitle: 'upsell_pagev1_feature1_desc',
  },
  {
    icon: <Design1Icon2 />,
    title: 'upsell_pagev1_feature2_title',
    subTitle: 'upsell_pagev1_feature2_desc',
  },
  {
    icon: <Design1Icon3 />,
    title: 'upsell_pagev1_feature3_title',
    subTitle: 'upsell_pagev1_feature3_desc',
  },
];

export const UPSELL_PAGE_DESIGN_2 = [
  {
    icon: <Design1Icon1 />,
    title: 'upsell_pagev1_feature1_title',
    subTitle: 'upsell_pagev2_feature1_desc',
  },
  {
    icon: <Design1Icon2 />,
    title: 'upsell_pagev1_feature2_title',
    subTitle: 'upsell_pagev2_feature2_desc',
  },
  {
    icon: <Design1Icon3 />,
    title: 'upsell_pagev1_feature3_title',
    subTitle: 'upsell_pagev2_feature3_desc',
  },
];

export const UPSELL_PAGE_DESIGN_3 = [
  {
    icon: <Design1Icon1 />,
    title: 'upsell_pagev1_feature1_title',
    subTitle: 'upsell_pagev2_feature1_desc',
  },
  {
    icon: <Design1Icon2 />,
    title: 'upsell_pagev1_feature2_title',
    subTitle: 'upsell_pagev2_feature2_desc',
  },
  {
    icon: <Design1Icon3 />,
    title: 'upsell_pagev1_feature3_title',
    subTitle: 'upsell_pagev2_feature3_desc',
  },
];

export const MergedApplyRWVar2Card = [
  {
    img: '/img/merge_var2_card1.png',
    name: 'merge_2_text_4',
    svg: <Texi />,
    designation: 'merge_2_text_5',
    span: 'merge_2_text_6',
    trade: 'merge_2_text_7',
    left_btn: 'merge_2_text_8',
    right_btn: 'merge_2_text_9',
  },
  {
    img: '/img/merge_var2_card2.png',
    name: 'merge_2_text_10',
    svg: <UserTrade />,
    designation: 'merge_2_text_11',
    span: 'merge_2_text_12',
    trade: 'merge_2_text_13',
    left_btn: 'merge_2_text_14',
    right_btn: 'merge_2_text_15',
  },
  {
    img: '/img/merge_var2_card3.png',
    name: 'merge_2_text_16',
    svg: <Clothes />,
    designation: 'merge_2_text_17',
    span: 'merge_2_text_18',
    trade: 'merge_2_text_19',
    left_btn: 'merge_2_text_20',
    right_btn: 'merge_2_text_21',
  },
];

export const MergedApplyRWList = [
  { listText: 'marge_1_text_2' },
  { listText: 'marge_1_text_3' },
  { listText: 'marge_1_text_4' },
];

export const MergedApplyVar3List = [
  { listText: 'marge_3_text_4' },
  { listText: 'marge_3_text_5' },
  { listText: 'marge_3_text_6' },
];

export const MergedApplyRWVar2IconsList = [
  { icon: <GoogleIcon />, companyName: 'Google' },
  { icon: <MicroSoftIcon />, companyName: 'Microsoft' },
  { icon: <AdobeIcon />, companyName: 'Adobe' },
  { icon: <DeltaAirIcon />, companyName: 'Delta Air' },
  { icon: <IkeaIcon />, companyName: 'Ikea' },
];

export const MergedApply1ImageDesign = [
  {
    icon: <ReviewIcon />,
    title: 'merge_1_img_block_text_1',
  },
  {
    icon: <EqualToIcon />,
    title: 'merge_1_img_block_text_2',
  },
  {
    icon: <UpArrowIcon />,
    title: 'merge_1_img_block_text_3',
  },
];
